const singleton = {

    notFound: () => {
        document.querySelector('[name="prerender-status-code"]').setAttribute("content", "404");
        return singleton;
    },

    redirect: (url, permanent = false) => {

        document.querySelector('[name="prerender-status-code"]').setAttribute("content", permanent ? "301" : "302");
        let metaLoc = document.querySelector('[name="prerender-header"]');
        if (!metaLoc) {
            metaLoc = document.createElement("meta");
            metaLoc.name = "prerender-header";
            document.head.appendChild(metaLoc);
        }
        metaLoc.setAttribute("content", `Location: ${url}`);
        return singleton;

    },

    isReady: (state) => {
        window.prerenderReady = !!state;
        return singleton;
    }

};

module.exports = singleton;